import { useEffect, useState } from 'react'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import useMainClass from 'hooks/use-main-cass'
import { LoadingDiv } from 'theme/loading'
import { useLocalStorage } from 'react-use'
import Rules from './components/Rules'
import Modal from './components/Modal'
import Header from './components/Header'
import ProgressBar from './components/ProgressBar'
import Code from './components/Code'
import { useReferral } from './hook/useReferral'
import Ranking from './components/Ranking'

const Referrals = () => {
  useMainClass('referrals')
  const [openRules, setOpenRules] = useState(false)
  const [{ dynamic, team }, { getReferredTeam, createClusterTeam }] = useReferral()
  const [modal, setModal] = useLocalStorage('referrals-onboarding', true)
  const [openRanking, setOpenRanking] = useState<boolean>(false)

  useEffect(() => {
    if (dynamic) getReferredTeam()
  }, [dynamic])

  const toggleRules = () => {
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: !openRules ? 'see rules' : 'close rules',
      section: 'referrals'
    })

    setOpenRules(!openRules)
  }

  const toggleRanking = () => {
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: !openRules ? 'see ranking' : 'close ranking',
      section: 'referrals'
    })

    setOpenRanking(!openRanking)
  }

  const referralCode = async () => {
    try {
      if (!team?.profileCluster) {
        await createClusterTeam()
      }
      setModal(false)
    } catch (error) {
      console.error('Error in referralCode:', error)
    }
  }

  if (!dynamic || !team) {
    return <LoadingDiv />
  }

  if (openRules) {
    return <Rules closeRules={toggleRules} />
  }

  if (modal) {
    return <Modal data={dynamic} closeModal={referralCode} toggleRules={toggleRules} />
  }

  if (openRanking) {
    return <Ranking toggleRanking={toggleRanking} team={team} />
  }

  return (
    <section className="w-full referral-content">
      <Header toggleRanking={toggleRanking} />
      <ProgressBar data={team} />
      <Code data={team} />
    </section>
  )
}

export default Referrals
